module.exports = __webpack_public_path__ + "img/tu_5.13934dc6.png";